import { fetcher } from '@commenda/utils';

export const deleteCapTableTransaction = async (transactionId: string) => {
  const res = await fetcher(`capTable/transaction/${transactionId}`, {
    method: 'DELETE',
  });

  return res;
};
